export default __webpack_public_path__ + "static/media/SIFA_FR_EPILOGUE01.76684882.mp3";